

























import { Vue, Component } from "vue-property-decorator";
import { isEmpty } from "@/utils/Common";
import { showWarning } from "@/utils/UI";

@Component
export default class Login extends Vue {
  username = "admin";
  password = "121212";
  isLogging = false;

  doLogin() {
    if (isEmpty(this.username)) {
      showWarning("请输入用户名");
      return;
    }
    if (isEmpty(this.password)) {
      showWarning("请输入密码");
      return;
    }

    const postedData = {
      loginType: "LOGIN_NAME",
      loginName: this.username,
      password: this.password
    };
    this.isLogging = true;
    this.$store.dispatch("user/login", postedData).then(() => {
      this.isLogging = false;
      const user = this.$store.getters["user/user"];
      if (!user) {
        return;
      }
      this.$router.push("index");
    });
  }
}
